import React from 'react'
//assets
import addButton from '../assets/img/Events__addButton.svg'
import '../assets/css/AddEvent.css'
//config
import config from '../config';
//Material UI Component
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
//store
import events from '../store/events';
import profile from '../store/profile';
import errors from '../store/errors';
import prompt from '../store/prompt';
import {observer} from 'mobx-react';
//plugin
import axios from 'axios';

// 正则只输入数字、英文字符、-、_
const reg = "^[a-zA-Z0-9-_' ']{0,20}$"

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width:200
  },
  formControl: {
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

@observer
class AddEvent extends React.Component {
  state = {
    errorType:'',
    eventName:'',
    open: false,
    requireInputError:false,
    type:'',
  }
  addEvent = this.addEvent.bind(this);
  handleClose = this.handleClose.bind(this);
  handleTypeChange = this.handleTypeChange.bind(this);
  createEvent = this.createEvent.bind(this);
  addEvent(){
    this.setState({
      open: true
    })
  }
  handleClose(){
    this.setState({
       open: false
     })
    this.clearState();
  }
  clearState(){
    this.setState({
      type:'',
      eventName:'',
      requireInputError:false
    })
  }
  createEvent(){
    const regus = new RegExp(reg)
    if(!regus.test(this.state.eventName)){
      window.alert('請輸入不超過20个數字、英文、下劃線或橫崗的字符')
      return;
    }
    //validate input
    if(this.state.eventName == ''){
      //prompt Error message
      this.setState({
        requireInputError:true,
        errorType: errors.type.empty,
      })
    }else if(events.checkDuplicateEvent(this.state.eventName)){
      this.setState({
        requireInputError:true,
        errorType: errors.type.duplicate,
      })
    }else if(this.state.eventName.length > 20 ){
      this.setState({
        requireInputError:true,
        errorType: errors.type.maxLength(20),
      })
    }else if(events.list.length >= 15){
      this.setState({
        requireInputError:true,
        errorType: errors.type.reachLimits,
      })
    }else{
      prompt.message('事件創建中,請稍等...');
      //Create event on database
      axios.post(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${events.newEvent.name}`,{})
      .then(response=>response.data.message === 'EVENT CREATE' && response.status === 200
      ?(
        events.addEvent(response.data.eventAPIKey)
        )
      :prompt.message('創建失敗.請稍後嘗試.'))
      .catch((error)=>{
        if(error.response.status === 429){
          prompt.message('創建失敗.無法創建更多的事件.')
        }
      })
      //Clear eventname and type state
      this.clearState();
      //Close dialog
      this.handleClose();
    }
  }
  handleTypeChange(event){
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
    events.newEvent.type = event.target.value;
  }
  handleEventNameChange = name => event => {
    
    this.setState({
      [name]: event.target.value,
      requireInputError:false
    });
    events.newEvent.name = event.target.value;
  };
  render () {
    const {classes} = this.props;

    return(
      <div className="AddEvent">
        <Tooltip title='創建事件'>
        <div className="AddEvent__addButton" onClick={this.addEvent}>
          <img src={addButton} alt='EventsAddButton' width='100%' />
        </div>
        </Tooltip>
        <Dialog
          open = {this.state.open}
          onClose = {this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          >
          <DialogTitle id="alert-dialog-title">創建事件</DialogTitle>
          <DialogContent >
            <DialogContentText id="alert-dialog-description">請為事件命名</DialogContentText>
            <div className={classes.root}>
              <FormControl className={classes.formControl} required>
                <TextField
                  id="eventName"
                  label="事件名"
                  value={this.state.eventName}
                  onChange={this.handleEventNameChange('eventName')}
                  margin="normal"
                  required
                  error = {this.state.requireInputError}
                  helperText={this.state.requireInputError? this.state.errorType : false}
                />
              </FormControl>
              {/*<FormControl className={classes.formControl} >
                <InputLabel htmlFor="type">類型</InputLabel>
                <Select
                  value={this.state.type}
                  onChange={this.handleTypeChange}
                  inputProps={{
                    name: 'type',
                    id:'type'
                  }}
                  >
                  <MenuItem value='trigger'>Trigger</MenuItem>
                  <MenuItem value='action'>Action</MenuItem>
                </Select>
              </FormControl>*/}
              </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              取消
            </Button>
            <Button onClick={this.createEvent} color="primary" autoFocus>
              創建
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(AddEvent);



// WEBPACK FOOTER //
// ./src/components/AddEvent.js